import { render } from "./ProfilesDashboardComponent.vue?vue&type=template&id=6a96c1a1"
import script from "./ProfilesDashboardComponent.vue?vue&type=script&lang=js"
export * from "./ProfilesDashboardComponent.vue?vue&type=script&lang=js"
script.render = render

export default script